import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "@/shared/auth";
import { BrowserRouter } from "react-router-dom";
import AppWithSocket from "./AppWithSocket";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <AppWithSocket />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);


